<script>
    import { LottiePlayer } from "@lottiefiles/svelte-lottie-player";
    import { onMount } from "svelte";
    import animationData from "../../../public/images/lottieRelax.json";
    import { screenStore } from "../../functions/stores";
    import ShowModal from "../../components/modal component/showModal.svelte";

    onMount(() => {});
    let videoClicked = false;
</script>

<div class="flex justify-center pt-20">
    <div class={$screenStore.width < 500 ? "smVideoBox" : "videoBox"}>
        <div
            on:keypress
            on:click={() => {
                videoClicked = true;
            }}
            class=" flex justify-center"
        >
            <LottiePlayer
                src={animationData}
                autoplay={true}
                loop={true}
                controls={false}
                renderer="svg"
                background="transparent"
                height={400}
                width={400}
            />
            <div class="bottomBox">
                
                <ShowModal />
            </div>
        </div>
    </div>
</div>

<style>
    .videoBox {
        border-radius: 20%;
        width: 40%;
        position: relative;
        background-color: #6b47e1ee;
    }
    .smVideoBox {
        border-radius: 10%;
        width: 80%;
        position: relative;
        background-color: #6b47e1ee;
    }
    .bottomBox {
        position: absolute;
        bottom: 40px;
        right: 40px;
    }
   
</style>
